import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

const CHECK_INTERVAL = 1800 * 1000 // Check every 30 minutes (adjust as needed)

export function useVersionCheck() {
  const router = useRouter()
  const isNewVersionAvailable = ref(false)
  const currentVersion = ref(null)
  const latestVersion = ref(null)
  const checkIntervalId = ref(null)

  // Function to fetch version.json
  const checkVersion = async () => {
    try {
      // Add timestamp to prevent browser caching of the json file
      const response = await fetch(`/version.json?t=${Date.now()}`)
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const contentType = response.headers.get('content-type')
      if (!contentType || !contentType.includes('application/json')) {
        throw new Error('version.json not found or invalid content type')
      }

      const data = await response.json()
      
      // Initialize current version on first load
      if (!currentVersion.value) {
        currentVersion.value = data
        return
      }

      // Compare timestamps to detect new builds
      // We use timestamp because version number might not change for every deployment
      if (data.timestamp > currentVersion.value.timestamp) {
        isNewVersionAvailable.value = true
        latestVersion.value = data
      }
    } catch (error) {
      console.error('Failed to check version:', error)
    }
  }

  const refreshApp = () => {
    window.location.reload()
  }

  onMounted(() => {
    // Initial check
    checkVersion()

    // Periodical check
    checkIntervalId.value = setInterval(checkVersion, CHECK_INTERVAL)

    // Check on route change (optional but recommended for SPAs)
    // We use a watcher or hook on the router if provided
    if (router) {
      router.afterEach(() => {
        checkVersion()
      })
    }
  })

  onUnmounted(() => {
    if (checkIntervalId.value) {
      clearInterval(checkIntervalId.value)
    }
  })

  return {
    isNewVersionAvailable,
    refreshApp,
    currentVersion
  }
}
